import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__image_asset_filter } from '@shared/dto/+image/_requests/DTO_REQUEST__image_asset_filter';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../generation/STATE__generation';

export const REMOTE__image_asset_filter = createAsyncThunkSafe<void, DTO_REQUEST__image_asset_filter>(
  ENUM__network_event_client_to_server.IMAGE_ASSET_FILTER,
  async (request): Promise<any> => {
    return await send_to_server(ENUM__network_event_client_to_server.IMAGE_ASSET_FILTER, request);
  },
);

export function INIT_REMOTE__image_asset_filter(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__image_asset_filter.pending, (state, action) => {})
    .addCase(REMOTE__image_asset_filter.rejected, (state, action) => {})
    .addCase(REMOTE__image_asset_filter.fulfilled, (state, action: PayloadAction) => {});
}
